import {
    useLocation,
    Navigate,
    Outlet,
    useParams
} from "react-router-dom";
import {useEffect, useState} from "react";



// `allow(role)`, when given, replaces `allowedRoles`: it lets a route follow a
// rule of helper/roles (the role read from localStorage is a string).
const RequireAuth = ({ allowedRoles, allow }) => {

    const useToken=()=>{
        const token =localStorage.getItem('xsrfToken')
        return !!token;
    }

    const useRole=()=>{
        return localStorage.getItem('rUser')
    }
    const [rAuth,setRAuth]=useState(useRole())
    const [tAuth,setTAuth]=useState(useToken())
    const location = useLocation();

    return (
        (allow ? allow(rAuth) : allowedRoles?.includes(rAuth))
            ? <Outlet />
            : tAuth
                ? <Navigate to="/unauthorized" state={{ from: location }} replace />
                : window.location.href=process.env.REACT_APP_ADMIN_LOGIN
    );
}

export default RequireAuth;